import style from './FormInput.module.scss';

const FormInput = ({ type = 'text', rows = null, ...attrs }) => {
  return rows ? (
    <textarea className={style.input} rows={rows} cols="20" {...attrs}></textarea>
  ) : (
    <input className={style.input} type={type} {...attrs} />
  );
};

export default FormInput;
